import { getSharedItems } from "../../../../../../services/savedItems";
import { getBoardShareId } from "../../../selectors";

const getSharedItemsRequest = ({ state, params }) =>
  getSharedItems({ ...params, shareId: getBoardShareId(state) });

export default getSharedItemsRequest;
